import { Controller } from "@hotwired/stimulus"

// FD-1189: keeps the rows "Load more" appended through a same-page refresh (an edit's
// redirect_back, a broadcast refresh). The server rendered only first pages, so the morph
// deleted the rest and the list shrank under the reader. This sends
// WorkItemQuery::LOADED_ROWS_HEADER naming the groups grown past their first page, and
// the server renders that many. The rows are fresh, so deleted or moved ones still go.
// A header, not a URL param: a URL changed behind Turbo's back makes the next edit a
// full visit (FD-1187), and a param would leak into bookmarks, links and cache keys.
const HEADER = "X-Flightdeck-Loaded-Rows"
const MAX_GROUPS = 50 // WorkItemQuery::LOADED_ROWS_MAX_GROUPS

export default class extends Controller {
  static targets = ["group"]
  static values = { groupBy: String }

  // turbo:before-fetch-request@document. Only a GET of this exact URL, or a form
  // submission (fetch follows its redirect_back with the same headers).
  attach(event) {
    const { fetchOptions, url } = event.detail || {}
    if (!fetchOptions?.headers || !this.#mayRefreshThisPage(fetchOptions.method, url)) return
    const value = this.#describe()
    if (value) fetchOptions.headers[HEADER] = value
  }

  #mayRefreshThisPage(method, url) {
    if (String(method).toUpperCase() !== "GET") return true
    const target = new URL(url, window.location.href)
    return target.pathname === window.location.pathname && target.search === window.location.search
  }

  #describe() {
    const entries = []
    for (const group of this.groupTargets) {
      if (entries.length >= MAX_GROUPS) break
      const rows = group.querySelectorAll(":scope > [data-item-url]").length
      if (rows > Number(group.dataset.loadedRowsFirstPage)) entries.push(`${group.dataset.loadedRowsToken}=${rows}`)
    }
    return entries.length ? [this.groupByValue, ...entries].join(";") : null
  }
}
